var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_307)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.667 48.6665C18.667 45.1303 20.0718 41.7389 22.5722 39.2384C25.0727 36.7379 28.4641 35.3332 32.0003 35.3332C35.5365 35.3332 38.9279 36.7379 41.4284 39.2384C43.9289 41.7389 45.3337 45.1303 45.3337 48.6665H42.0003C42.0003 46.0143 40.9468 43.4708 39.0714 41.5954C37.196 39.7201 34.6525 38.6665 32.0003 38.6665C29.3482 38.6665 26.8046 39.7201 24.9293 41.5954C23.0539 43.4708 22.0003 46.0143 22.0003 48.6665H18.667ZM32.0003 33.6665C26.4753 33.6665 22.0003 29.1915 22.0003 23.6665C22.0003 18.1415 26.4753 13.6665 32.0003 13.6665C37.5253 13.6665 42.0003 18.1415 42.0003 23.6665C42.0003 29.1915 37.5253 33.6665 32.0003 33.6665ZM32.0003 30.3332C35.6837 30.3332 38.667 27.3498 38.667 23.6665C38.667 19.9832 35.6837 16.9998 32.0003 16.9998C28.317 16.9998 25.3337 19.9832 25.3337 23.6665C25.3337 27.3498 28.317 30.3332 32.0003 30.3332Z",
    fill: "#7E8392"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.3d2eb7cd0dd5926fd3b8556289c81288.svg";
export { ForwardRef as ReactComponent };